import { CustomArray } from "../../../common/CustomArray.js";
import {DriveSimpleItem} from "./DriveSimpleItem.js";
import { GuidUtility } from "../../../common/GuidUtility.js";


/// <summary>
/// 简化的行驶信息，不一定存在 oyyh,20161008添加注释
/// </summary>
export class DriveSimpleItems extends CustomArray {

	constructor() {
		super();
	}

	static GetDriveSimpleItems(objProxy) {
		let simpleItems=null;
		if(objProxy==null)return simpleItems;

		simpleItems=new DriveSimpleItems();
		let items = objProxy.item ;
		let tempSimpleItem=null;
		for (let tempIndex in items) 
		{	
			tempSimpleItem = DriveSimpleItem.GetDriveSimpleItem(items[tempIndex]);
			tempSimpleItem.id=GuidUtility.getGuid();
			simpleItems.push(tempSimpleItem);
		}

		return simpleItems;
	}

}//end DriveSimpleItems

